import styled from 'styled-components'

export const Container = styled.div`
    width: 336px;
    position: absolute;
    z-index: 200;
    right: 22px;
    top: 60px;
    bottom: 22px;
    flex-shrink: 0;
    background-color: var(--color-white);
    border-radius: 8px;
    box-shadow: 0 0 0 1px var(--color-gray-200);
    display: flex;
    flex-direction: column;
    /* border: 1px solid var(--color-gray-200); */
`

export const Header = styled.div`
    width: 100%;
    flex: 0;
    padding: 16px;
`

export const CardInfo = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-bottom: 12px;
`

export const Info = styled.div`
    flex: 1;
    display: flex;
    justify-content: space-between;
    overflow: hidden;
    gap: 12px;
`

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 16px 16px 16px;
    padding-top: 12px;
    gap: 12px;
    flex: 1;
    overflow-y: auto;
`

export const Capability = styled.div`
    padding: 8px 12px;
    background-color: var(--color-gray-100);
    border-radius: 8px;
`

export const CapabilityTitle = styled.div`
    font-size: 14px;
    color: var(--color-black);
    line-height: 22px;
    font-weight: 600;
`

export const CapabilityDescribe = styled.div`
    font-size: 12px;
    color: var(--color-gray-500);
    line-height: 20px;
    margin-top: 4px;
`
